import qs from 'qs'
import _ from 'lodash'
import type { DeployEnv } from '@patsnap-utils/biz';
import { SLD, Site } from '@patsnap-utils/biz';

export function safeGetLocaleStorage(key: string) {
    try {
        return localStorage.getItem(key)
    } catch (e) {
        console.error(e)
        return null
    }
}

function getHashParams(hash: string, key: string) {
    if (hash.startsWith('/')) {
        hash = hash.substring(1);
    }
    const queryIndex = hash.indexOf('?');
    if (queryIndex !== -1) {
        const query = hash.substring(queryIndex + 1);

        const urlParams = new URLSearchParams(query);
        return urlParams.get(key)
    }
    return undefined
}

export function getVar(key: string, type: ('string' | 'boolean') = 'string'): any {
    const hash = window.location.hash.substring(1);
    if (hash) {
        return getHashParams(hash, key);
    }
    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    if (_.has(query, key)) {
        const value = _.get(query, key) as string
        if (_.isNull(value) || _.isUndefined(value)) {
            return true
        }
        if (type === 'boolean') {
            if (_.lowerCase(value) === 'false') {
                return false
            } else {
                return true
            }
        }
        return value
    }

    const res = safeGetLocaleStorage(key)
    if (_.isNull(res)) {
        return undefined
    }
    return res
}

export let REGION: DeployEnv = new Site({ sld: SLD.EUREKA }).env
const debug_region = getVar('debug_region')
if (debug_region) {
    console.warn(`使用替换Region ${REGION} => ${debug_region}`)
    REGION = debug_region
}
